import newsFrom from '../templateManage/templateFrom/newsFrom.vue';
export default {
  components: {
    newsFrom
  },
  data() {
    return {
      content: ''
    };
  }
};